import script from "./RadioButton.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioButton.vue?vue&type=script&setup=true&lang=js"

import "./RadioButton.vue?vue&type=style&index=0&id=e2b40ee0&lang=css"

const __exports__ = script;

export default __exports__